var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Banner.styles.scss';
import Button from '../Button/Button';
import Icon from '../Icon/Icon';
var Banner = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'success' : _b, text = _a.text, labelActionOne = _a.labelActionOne, labelActionTwo = _a.labelActionTwo, handleActionOne = _a.handleActionOne, handleActionTwo = _a.handleActionTwo, bannerWithIcon = _a.bannerWithIcon;
    var renderIcon = function (iconVariant) {
        var iconVariants = {
            success: 'CheckCircle',
            danger: 'CloseCircle',
            warning: 'InfoCircle',
        };
        return (_jsx(Icon, { option: iconVariants[iconVariant], size: "sm" }));
    };
    return (_jsxs("div", __assign({ className: "hefesto-banner hefesto-banner--".concat(variant, " \n      hefesto-banner--").concat(labelActionTwo ? 'two-buttons' : 'one-button', "\n      "), "data-testid": "banner-component" }, { children: [_jsxs("div", __assign({ className: "hefesto-banner__text" }, { children: [bannerWithIcon && (_jsx("div", __assign({ className: "hefesto-banner__icon" }, { children: renderIcon(variant) }))), _jsx("span", __assign({ className: "hefesto-banner__message" }, { children: text }))] })), _jsxs("div", __assign({ className: "hefesto-banner__buttons hefesto-banner__buttons--".concat(labelActionTwo ? 'two-buttons' : 'one-button') }, { children: [_jsx(Button, __assign({ variant: variant !== 'danger' ? 'neutral' : 'neutral-inverse', name: labelActionOne, onClick: handleActionOne }, { children: _jsx("span", __assign({ className: "hefesto-banner__title-action-primary" }, { children: labelActionOne })) })), labelActionTwo && (_jsx(Button, __assign({ variant: variant !== 'danger' ? 'neutral' : 'neutral-inverse', name: labelActionTwo, onClick: handleActionTwo }, { children: _jsx("span", __assign({ className: "hefesto-banner__title-action-secondary" }, { children: labelActionTwo })) })))] }))] })));
};
export default Banner;
